import { createSelector } from 'reselect';

import { iUiStore } from 'types/ui';
import { RootState } from 'types/store';

const selectUi = (state: RootState) => state.ui;

const selectIsOpenSidebar = createSelector(selectUi, (ui: iUiStore) => ui.isOpenSidebar);
const selectIsConnectionLost = createSelector(selectUi, (ui: iUiStore) => ui.isConnectionLost);

export { selectIsOpenSidebar, selectIsConnectionLost };
